module.exports = __webpack_public_path__ + "static/media/oil.199f8b33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/oil.jpg
// module id = 123
// module chunks = 0